/**
 * Slice 49 / C2 — shown once per person before their first start. No back, no "not now":
 * Continue always leads on to the phone's own prompt, and whatever they answer there the job starts.
 */
import { CLEANER_SIMPLE_CTA_FOOTER, CLEANER_SIMPLE_STEP_SHELL_MIN } from "@/lib/turnoverChrome";
import { useTranslation } from "@/hooks/useTranslation";

export function LocationIntroStep({ onContinue }: { onContinue: () => void }) {
  const { t } = useTranslation();
  return (
    <div className={CLEANER_SIMPLE_STEP_SHELL_MIN}>
      <div className="flex flex-1 flex-col justify-center gap-[22px] px-7">
        <div className="flex h-[84px] w-[84px] items-center justify-center rounded-full bg-[#e2eeed]">
          <div className="h-7 w-7 rounded-full border-[6px] border-white bg-[#24a89a]" />
        </div>
        <div className="text-[30px] font-bold leading-[1.15] tracking-[-0.6px] text-[#0f1720]">
          {t("locationIntroTitle")}
        </div>
        <div className="text-[19px] font-medium leading-[1.5] text-[#334155] [text-wrap:pretty]">
          {t("locationIntroBody")}
        </div>
      </div>
      <div className={CLEANER_SIMPLE_CTA_FOOTER}>
        <button
          type="button"
          onClick={onContinue}
          className="flex h-[68px] w-full items-center justify-center rounded-[18px] bg-[#24a89a] text-[22px] font-bold text-white hover:bg-[#1f958a]"
        >
          {t("continue")}
        </button>
      </div>
    </div>
  );
}
